<template>
  <div class="fixed bottom-0 left-0 z-50 w-full">
    <div class="card-shadow bg-background-neutral-secondary rounded-t-2xl p-4">
      <slot />
      <div class="mb-4 flex w-full items-center justify-between">
        <div class="flex flex-col gap-1">
          <p
            v-price="priceAmount"
            class="text-text-neutral-primary text-lg font-bold"
          />
          <div
            v-if="cashbackAmount > 0"
            class="freedom-background-color rounded-full px-1.5 py-0.5"
          >
            <i18n-t
              class="freedom-loyalty-text text-xs font-semibold"
              keypath="details.cashback"
              tag="p"
            >
              <template #amount>
                <span v-price="cashbackAmount" />
              </template>
            </i18n-t>
          </div>
        </div>
        <FreeButton
          :disabled="isLoading"
          class="green-main-button w-1/2 min-w-fit"
          type="button"
          @click="emit('onButtonAction')"
          >{{ buttonTitle || t('general.proceed') }}
        </FreeButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeButton, freedomCashbackModel } from 'freedom-shared';

  import { api } from '@/shared/api';

  const { t } = useI18n();

  const props = withDefaults(
    defineProps<{
      sourcePage?: string;
      priceAmount: number | string;
      billId?: string;
      buttonTitle?: string;
      isLoading?: boolean;
    }>(),
    {
      isLoading: false,
      billId: '',
      buttonTitle: '',
      sourcePage: '',
    },
  );

  const emit = defineEmits<{
    onButtonAction: [];
  }>();

  const { amount: cashbackAmount } = freedomCashbackModel.useFreedomCashback({
    pfm: api,
    offerPrice: computed(() => props.priceAmount),
    billId: props.billId,
  });
</script>

<style scoped>
  .card-shadow {
    box-shadow: 0px -6px 20px 0px #00000014;
  }
</style>
